module.exports = __webpack_public_path__ + "img/diners.720637e8.svg";